import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { reduce, orderBy, head, find, uniqWith } from 'lodash'
import KeyFiguresParmeters from './KeyFiguresParmeters'
import DtoAnalysis from '../../dto/DtoAnalysis'
import { connect } from 'react-redux'
import moment from 'moment'
import DtoPickupOperation from '../../dto/DtoPickupOperation'
import DtoParameter from '../../../referential/dto/DtoParameter'
import { getRemarks } from '../../../utils/AnalysisUtils'
import DtoRemark from '../../../referential/dto/DtoRemark'
import { Timeserie, Plot, IChart } from 'react-aquasys'
import i18n from 'simple-react-i18n'

class FilterParameterChartPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			width: 0
		}
	}

	componentDidMount() {
		this.setState({ width: this.refs.filterParameter.offsetWidth })
	}

	getTitle = (filterId) => {
		if (this.props.parameters.length > 0 && filterId) {
			const result = find(this.props.parameters, (parameter) => {
				return parameter.id == filterId
			})
			if (result) {
				return result.name
			}
			return filterId
		}
		return filterId
	}


	getReferencialRemark = (id) => {
		if (this.props.remarks.length > 0) {
			return find(this.props.remarks, (o) => {
				return o.id == id
			})
		}
		return null
	}

	getSeries = (analysis) => {
		const reduceData = reduce(analysis, (o, v) => {
			if (v.remarkCode) {
				(o[v.remarkCode] || (o[v.remarkCode] = [])).push(v)
			}
			return o
		}, {})
		const line = orderBy(analysis.map((sec) => {
			return {
				x: parseInt(moment(sec.analysisDate).format('x')),
				y: sec.result
			}
		}), ['x'], ['asc'])
		if (Object.keys(reduceData).length > 1) {
			const dataResult = Object.keys(reduceData).map((rem) => {
				const data = orderBy(reduceData[rem].map((measure) => {
					return {
						x: parseInt(moment(measure.analysisDate).format('x')),
						y: measure.result
					}
				}), ['x'], ['asc'])
				const plotChoice = getRemarks(rem)
				const remarkRef = this.getReferencialRemark(plotChoice.id)
				return new Plot({ data: data, color: 'blue', name: remarkRef ? remarkRef.mnemonique : 'Line', plot: plotChoice.plot })
			})
			return [].concat([new Timeserie({ data: line, color: 'blue', name: i18n.reference })], dataResult)
		}
		if (Object.keys(reduceData).length > 0) {
			const plotChoice = getRemarks(Object.keys(reduceData)[0])
			const remarkRef = this.getReferencialRemark(plotChoice.id)

			return [new Timeserie({ data: line, color: 'blue', name: remarkRef ? remarkRef.mnemonique : i18n.reference, plot: plotChoice.plot })]
		}

		return [new Timeserie({ data: line, color: 'blue', name: i18n.reference, plot: 'square' })]
	}

	getChart = () => {
		const filterByParameter = reduce(this.props.analysis, (result, value) => {
			(result[value.parameters] || (result[value.parameters] = [])).push(value)
			return result
		}, {})
		let dataFilter = Object.keys(filterByParameter).find((filter) => {
			return filter === this.props.selectedValue
		})
		if (!dataFilter) {
			dataFilter = head(Object.keys(filterByParameter).sort())
		}
		const filterBySupport = reduce(filterByParameter[dataFilter], (result, value) => {
			(result[value.support] || (result[value.support] = [])).push(value)
			return result
		}, {})
		let dataSupportFilter = Object.keys(filterBySupport).find((filter) => {
			return filter === this.props.selectedSupport
		})
		if (!dataSupportFilter) {
			dataSupportFilter = head(Object.keys(filterBySupport).sort())
		}

		const dataSelected = uniqWith([].concat(filterByParameter[dataFilter], filterBySupport[dataSupportFilter]), (a, b) => {
			return a.id === b.id
		})
		const selectedAnalysis = dataSelected.map((m) => {
			if (m.analysisDate) {
				return m
			}
			const operation = find(this.props.pickupOperations, (o) => {
				return o.id === m.pickupOperationId
			})
			return Object.assign({}, m, {
				analysisDate: operation.date
			})
		})

		return (
			<div className='row no-margin'>
				<div className='col s12 m4 l4 no-padding'>
					<KeyFiguresParmeters analysis={ selectedAnalysis } />
				</div>
				<div className='col s12 m8 l8 no-padding'>
					<IChart height='350'
						series={ this.getSeries(selectedAnalysis) } legend />
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className='row no-margin'>
				<div className='col s6 m6 l12 no-margin no-padding' ref='filterParameter'>
					<div className='row no-margin'>
						{ this.getChart() }
					</div>
				</div>
			</div>
		)
	}

}

FilterParameterChartPanel.propTypes = {
	analysis: PropTypes.arrayOf(PropTypes.objectOf(DtoAnalysis)),
	pickupOperations: PropTypes.arrayOf(PropTypes.objectOf(DtoPickupOperation)),
	parameters: PropTypes.arrayOf(PropTypes.objectOf(DtoParameter)),
	selectedValue: PropTypes.string,
	selectedSupport: PropTypes.string,
	remarks: PropTypes.arrayOf(PropTypes.objectOf(DtoRemark))
}
FilterParameterChartPanel.defaultProps = {
	analysis: [],
	pickupOperations: [],
	parameters: [],
	selectedValue: '',
	selectedSupport: ''
}

const mapStateToProps = store => {
	return {
		analysis: store.DetailStationReducer.analysis,
		pickupOperations: store.DetailStationReducer.pickupOperations,
		parameters: store.ReferentialReducer.parameters,
		remarks: store.ReferentialReducer.remarks
	}
}

export default connect(mapStateToProps)(FilterParameterChartPanel)



// WEBPACK FOOTER //
// ./src/station/components/qualitometer/FilterParameterChartPanel.js